import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";

const TextGenerateEffect = ({ text, onComplete }) => {
  const [displayText, setDisplayText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!text) return;

    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setDisplayText((prev) => prev + text[currentIndex]);
        setCurrentIndex((prev) => prev + 1);
      }, 15); // Adjust speed here (lower = faster)

      return () => clearTimeout(timeout);
    } else if (onComplete) {
      onComplete();
    }
  }, [text, currentIndex, onComplete]);

  useEffect(() => {
    // Reset when text changes
    setDisplayText("");
    setCurrentIndex(0);
  }, [text]);

  return (
    <Box
      component="div"
      sx={{
        "& .typing-text": {
          display: "inline",
          position: "relative",
          "&::after": {
            content: '"|"',
            position: "absolute",
            right: "-4px",
            animation: "blink 1s infinite",
          },
        },
        "@keyframes blink": {
          "0%, 100%": {
            opacity: 1,
          },
          "50%": {
            opacity: 0,
          },
        },
      }}
    >
      <span className="typing-text">{displayText}</span>
    </Box>
  );
};

export default TextGenerateEffect;
